import React, { useState, Fragment, useEffect, useContext, useCallback } from "react";
import InputFilter from "../../../components/InputFilter";
import FilterResults from "react-filter-search";
import TrainingAccordionTable from "../../../components/TrainingAccordionTable";
import { AuthContext } from "context/AuthContext";
import { getUnificationImpactEvulations } from "services/NexiDigitalAPI";
import PreloaderBlur from "containers/PeopleCraft/PreloaderBlur";
import CustomPagination from "containers/PeopleCraft/CustomPagination/CustomPagination";


const UnifiedAssessmentsTab: React.FC = () => {
  const { loginData }: { loginData: any } = useContext(AuthContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [textSearch, setSearch] = useState("");
  const [trainings, setTrainings] = useState([]);
  const [error, setError] = useState<string | null>(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value);
  const cleanSearch = () => setSearch("");

  const getTrainings = useCallback(
    async (page, limit) => {
      const offset =  page === 0 ? 0 : (page - 1) * limit
      if (!loginData?.userid) {
        setError("Dados de login não disponíveis");
        return;
      }
      setLoading(true);

      try {
        const response = await getUnificationImpactEvulations(loginData?.userid, {
          searchString: textSearch,
          limit,
          offset,
        });

        setTrainings(response?.data.result);
        setTotalRecords(response?.data.totalRecords);
      } catch (e) {
        setTrainings([]);
        setError("Erro ao carregar dados da equipe");
      } finally {
        setLoading(false);
      }
    },
    [loginData.userid, textSearch]
  );

  useEffect(() => {
    getTrainings(currentPage, perPage);
  }, [currentPage, getTrainings, perPage]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {loading && <PreloaderBlur />}
      <InputFilter
        textSearch={textSearch}
        handleChangeName={handleChangeName}
        cleanSearch={cleanSearch}
        placeholder="Pesquisar por treinamento..."
      />
      <div className="accordionTeam" style={{ marginTop: 10 }}>
        <FilterResults
          value={textSearch}
          data={
           trainings
          }
          renderResults={(results) => (
            <>
              {results.length === 0 && <p>Não foi encontrado nenhum treinamento</p>}
              {results.map((training) => (
                <Fragment key={training.id}>
                  <TrainingAccordionTable training={training} />
                </Fragment>
              ))}
            </>
          )}
        />
      </div>
      {Boolean(trainings?.length) && (
        <CustomPagination
          page={currentPage}
          rowsPerPage={perPage}
          totalCount={totalRecords}
          onPageChange={(newPage) =>  setPerPage(newPage)}
          onRowsPerPageChange={(newRows) => {
            setPerPage(newRows);
            setCurrentPage(0);
          }}
        />
      )}
    </div>
  );
};

export default UnifiedAssessmentsTab;
